import restaurantApi from '@/api/restaurant'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  id: 0,

  accountNo: null,
  qrAuthToken: null,
  payLinkAuthToken: null,

  hasAccountNo: false,
  hasQrAuthToken: false,
  hasPayLinkAuthToken: false,

  isOnlinePaymentEnabled: true,

  shownSecrets: {
    accountNo: null,
    qrAuthToken: null,
    payLinkAuthToken: null,
  },

  secretsError: null,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  async fetchConfigurationById({ commit }, id) {
    commit('FORM_RESET')
    try {
      const { data } = await restaurantApi.getConfigurationById(id)
      commit('RESTAURANT_CONFIGURATION_FETCHED', data)
    } catch (err) {
      commit('RESTAURANT_CONFIGURATION_FETCH_FAILED', err)

      return
    }

    try {
      const { data } = await restaurantApi.getSecretsById(id)
      commit('RESTAURANT_SECRETS_FETCHED', data)
    } catch {
    }
  },
  updateConfiguration({ commit }) {
    const payload = { id: state.id, isOnlinePaymentEnabled: state.isOnlinePaymentEnabled }
    const changed = field => state[field] && state[field] !== state.shownSecrets[field]
    if (changed('accountNo')) payload.accountNo = state.accountNo
    if (changed('qrAuthToken')) payload.qrAuthToken = state.qrAuthToken
    if (changed('payLinkAuthToken')) payload.payLinkAuthToken = state.payLinkAuthToken

    return restaurantApi.updateConfiguration(payload)
      .catch(error => {
        commit('RESTAURANT_CONFIGURATION_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  SET_LIST(state, data) {
    state.list = data
  },
  RESTAURANT_CONFIGURATION_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'PUSH_NOTIFICATION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  RESTAURANT_CONFIGURATION_FETCHED(state, data) {
    Object.assign(state, data)
  },
  RESTAURANT_SECRETS_FETCHED(state, data) {
    state.accountNo = data.accountNo
    state.qrAuthToken = data.qrAuthToken
    state.payLinkAuthToken = data.payLinkAuthToken
    state.shownSecrets = {
      accountNo: data.accountNo,
      qrAuthToken: data.qrAuthToken,
      payLinkAuthToken: data.payLinkAuthToken,
    }
    state.secretsError = data.error
  },
  RESTAURANT_CONFIGURATION_FETCH_FAILED() {
    store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch')
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
